import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { searchActions } from '../../store/searchStore';
import { BbSelectNoFormik } from '../styling/bbInput'
import { Translate, withLocalize } from 'react-localize-redux';
import classnames from 'classnames';
import SortUpIcon from '../../img/icons/SortingUp';
import SortDownIcon from '../../img/icons/SortingDown';
import { isNullOrUndefined } from '../../store/storeFunctions';

import './searchResultsManager.scss';
import { selectDefaultStyles } from '../styling/selectDefaultStyles';
import { userContextActions } from '../../store/userContextStore';
import MarkIcon from '../../img/icons/BBicons_Zalozka'
import BbPopover from '../common/popover'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class SearchResultsManager extends React.Component {

    orderByPrefix = 'SearchResult.OrderBy.';
    options = ['Relevance', 'FullName', 'CompanyId', 'BirthDate', 'Revenues', 'Equity', 'PP', 'ROS', 'ROE', 'Employees', 'Profit', 'ROA'];
    state = {
        selectedOption: 'Relevance',
        descending: true
    };


    handleChange = selectedOption => {
        this.props.changeSort(selectedOption.value, true);
        this.setState({ selectedOption: selectedOption.value, descending: true });
    };

    descendingClick = () => {
        this.props.changeSort(this.state.selectedOption, !this.state.descending);
        this.setState({ descending: !this.state.descending });
    }

    render() {
        let iconColor =  this.props.user.authentication.profile.displaySettings.tint === 'header' ? "#FFFFFF" : "#8f8d8d";
        return (
            <div className={classnames('search-results-manager-wrapper shadowed is-sticky', {"tinted" :this.props.tinted })}>
                {this.props.searchResult && (<div className='search-results-manager'>
                    <div className='result-counts-ordering-paging'>
                        <div className='result-counts'>
                            <span>
                                <Translate id='SearchResult.ResultsCount' />:&nbsp;
                                <b>{!isNullOrUndefined(this.props.searchResult.data) && this.props.searchResult.data.currentFound}</b> |&nbsp;
                                <Translate id='SearchResult.TotalResults' />:&nbsp;
                                <b>{!isNullOrUndefined(this.props.searchResult.data) && this.props.searchResult.data.totalFound}</b>
                            </span>
                        </div>
                        <div className='result-sorting'>
                            <span className='sorting-label' style={{marginRight:'.25em'}}><Translate id='SearchResult.OrderBy' />:</span>
                            <span className='sorting-type-selection-wrapper'>
                                <BbSelectNoFormik
                                    value={{ value: this.state.selectedOption, label: this.props.translate(`${this.orderByPrefix}${this.state.selectedOption}`) }}
                                    options={this.options.map(opt => ({ value: opt, label: this.props.translate(`${this.orderByPrefix}${opt}`) }))}
                                    onChange={this.handleChange} isSearchable={false} styles={{ ...selectDefaultStyles, indicatorsContainer: base => base }}
                                />
                            </span>
                            {this.state.descending ?
                                <SortDownIcon className='search-results-manager-fill with-pointer svg-standard-fill' onClick={this.descendingClick} /> :
                                <SortUpIcon className='search-results-manager-fill with-pointer svg-standard-fill' onClick={this.descendingClick} />                                
                            }
                        </div>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <BbPopover content={'Search.Extended.Tooltip'}  placement="right" targetId='searchTooltip' contentAsTranslateId>
                                    <span href="#" className="icon-grey print-hidden" id='searchTooltip' style={{ cursor: "pointer" }}><FontAwesomeIcon icon="question-circle" color={iconColor} style={{width: '1.5em', height: '1.5em'}}/></span>   
                            </BbPopover>

                            {typeof this.props.onSearchInfoLinkClick === 'function' &&
                                <span className='further-info-link'>
                                    <span className="icon-gray" title={this.props.translate("Common.MoreInformation")} onClick={this.props.onSearchInfoLinkClick}>
                                        <MarkIcon id='searchTooltip' className='with-pointer' />
                                    </span>
                                </span>}
                        </div>
                    </div>
                </div>)}
            </div>
        )
    }
}


export default withLocalize(connect(
    state => ({ ...state.search, layout: state.layout,  user:state.userContext }),
    dispatch => bindActionCreators(searchActions, dispatch),
)(SearchResultsManager));